module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/Poppins-SemiBold.6f1520d1.ttf";